<template>
  <CCardBody>
    <div v-if="!showSuccess">
      <div class="mb-3">
        <span class="font-weight-semi-bold span-click" @click="showFields()">{{ $t('manageplan.component.card.voucher.title') }}</span>
      </div>
      <div v-if="showInputVoucher">
        <CRow alignVertical="center">
          <CCol>
            <CInput
              :disabled="loadign"
              v-model="voucher"
              :placeholder="$t('manageplan.component.card.voucher.input.placeholder')"
              style="margin-bottom: 0px"
            />
          </CCol>
          <CCol sm="3">
            <CButton @click="validateVoucher()" :disabled="loadign" variant="outline" color="primary" class="py-2 px-5">{{
              $t('manageplan.component.card.voucher.button.apply')
            }}</CButton>
          </CCol>
          <CCol sm="1" class="ml-3">
            <CButton :disabled="loadign" @click="hideFields()">
              <CIcon name="cross" size="custom-size" :height="14" viewBox="0 0 32 32" />
            </CButton>
          </CCol>
        </CRow>
        <div v-if="showError" class="mt-1 text-error">{{ $t('manageplan.component.card.voucher.error.text') }}</div>
      </div>
    </div>
    <div v-else>
      <CRow class="mb-4">
        <CCol class="font-weight-bold">
          {{ $t('manageplan.component.card.voucher.success.title') }}
          {{ voucher }}
        </CCol>
        <CCol class="text-right">
          <span class="span-click text-primary" @click="removeVoucher()">{{ $t('manageplan.component.card.voucher.success.remove.button') }}</span>
        </CCol>
      </CRow>
      <CRow class="mb-4">
        <CCol xs="1" class="pl-3">
          <CIcon name="check" size="custom-size" :height="14" viewBox="0 0 32 32" />
        </CCol>
        <CCol>
          <div v-html="$t('manageplan.component.card.voucher.success.text', { value: discountValue.toFixed(2) })"></div>
        </CCol>
      </CRow>
    </div>
  </CCardBody>
</template>

<script>
import services from '@/services.js'
import { mapState } from 'vuex'

export default {
  data() {
    return {
      showInputVoucher: false,
      showError: false,
      showSuccess: false,
      voucher: 'ABC123',
      loadign: false,
      discountValue: 102,
    }
  },
  computed: {
    ...mapState('backOffice/steps', ['totalPrice']),
  },
  methods: {
    showFields() {
      this.showInputVoucher = true
      this.showError = false
      this.voucher = ''
    },
    hideFields() {
      this.showInputVoucher = false
    },
    validateVoucher() {
      this.loadign = true

      this.showError = false

      let planIdAux = this.$store.state.backOffice.steps.selectedPlanId
      let planTierIdAux = this.$store.state.backOffice.steps.selectedTierId
      let periodPlanTierPriceIdAux = this.$store.state.backOffice.steps.periodPlanTierPriceId
      let organizationId = this.$route.params.organizationId
      let { countryId, detailCountry, taxIdentificationNumber } = this.$store.state.backOffice.steps.billingInfo
      const isBillingDataRequested = this.$store.state.backOffice.steps.billingInfo.isBillingDataRequested

      let data = {
        code: this.voucher,
        planId: planIdAux,
        planTierId: planTierIdAux,
        periodPlanTierPriceId: periodPlanTierPriceIdAux,
        organizationId: organizationId,
        countryId: countryId,
        taxIdentificationNumber: taxIdentificationNumber,
        detailCountry: detailCountry,
        isBillingDataRequested,
      }

      services
        .validateVoucher(data)
        .then((res) => {
          // Guarda os dados do plano sem o Voucher, para caso de remoção
          this.storePreviousPlan(planIdAux, planTierIdAux, periodPlanTierPriceIdAux)
          let { planId, planTierId, periodPlanTierPriceId, iva, price, totalPrice } = res.data.data.planSummary
          this.discountValue = res.data.data.discount
          let promoConfigId = res.data.data.promoConfig.id
          this.storePlanData(planId, planTierId, periodPlanTierPriceId, price, iva, totalPrice, promoConfigId)
          this.showSuccess = true

          this.$emit('updateTotal')
        })
        .catch((err) => {
          this.showError = true
          this.loadign = false
          this.showSuccess = false
        })
        .finally(() => {
          this.loadign = false
        })
    },

    storePreviousPlan(planId, planTierId, periodPlanTierPriceId) {
      let { mount, tax, totalPrice } = this.$store.state.backOffice.steps
      let previousPlan = this.$store.state.backOffice.steps.previousPlan

      let previousPlanObj = {
        planId: previousPlan?.planid || planId,
        planTierId: previousPlan?.planTierId || planTierId,
        periodPlanTierPriceId: previousPlan?.periodPlanTierPriceId || periodPlanTierPriceId,
        mount: previousPlan?.mount || mount,
        tax: previousPlan?.tax || tax,
        totalPrice: previousPlan?.totalPrice || totalPrice,
      }

      // Guarda os dados do plano anterior
      this.$store.dispatch('backOffice/steps/updateInfoPropStep', { prop: 'previousPlan', data: previousPlanObj })
    },

    storePlanData(planId, planTierId, periodPlanTierPriceId, mount, tax, totalPrice, promoConfigId) {
      this.$store.dispatch('backOffice/steps/updateInfoPropStep', { prop: 'totalPrice', data: totalPrice })
      this.$store.dispatch('backOffice/steps/updateInfoPropStep', { prop: 'selectedPlanId', data: planId })
      this.$store.dispatch('backOffice/steps/updateInfoPropStep', { prop: 'selectedTierId', data: planTierId })
      this.$store.dispatch('backOffice/steps/updateInfoPropStep', { prop: 'periodPlanTierPriceId', data: periodPlanTierPriceId })
      this.$store.dispatch('backOffice/steps/updateInfoPropStep', { prop: 'mount', data: mount })
      this.$store.dispatch('backOffice/steps/updateInfoPropStep', { prop: 'tax', data: tax })
      this.$store.dispatch('backOffice/steps/updateInfoPropStep', { prop: 'promoConfigId', data: promoConfigId })
    },

    checkPlanInfo(planId, planTierId, periodPlanTierPriceId) {
      services
        .getPlansInfo(planId)
        .then((res) => {
          let planTiers = res.data.data.planTiers
          let periodPlanTierPrices = res.data.data.periodPlanTierPrices

          let tier = planTiers.find((el) => el.id == planTierId)
          let period = periodPlanTierPrices.find((el) => el.id == periodPlanTierPriceId)
          this.showSuccess = true
        })
        .catch((error) => {
          this.showError = true
        })
        .finally(() => {
          this.loadign = false
        })
    },

    removeVoucher() {
      this.voucher = ''
      this.showSuccess = false

      let { planId, planTierId, periodPlanTierPriceId, iva, mount, totalPrice } = this.$store.state.backOffice.steps.previousPlan

      this.storePlanData(planId, planTierId, periodPlanTierPriceId, mount, iva, totalPrice)
      this.$emit('updateTotal')
    },
  },
}
</script>
<style lang="scss">
.span-click {
  cursor: pointer;
  text-decoration-line: underline;
}
</style>
